<template>
<v-container fluid>
    <v-row justify="center">
        <v-flex xs6 sm4 md2 lg1 mt-2>
            <router-link to="/megogo/">
                <v-img src="/img/megogo.png" :transition="false"></v-img>
            </router-link>
        </v-flex>
    </v-row>
    <div class="text-center white--text mt-8">
        <h4>Нажаль, ми маємо недостатньо даних для надання повного доступу до сервісу.</h4>
        <p>Заповніть, будь ласка, форму для уточнення.</p>
     </div>   
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg4>
            <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                <material-card class="text-center title font-weight-bold" color="cardheader" light title="Уточнення даних" :text="(formSended ? '':'Укажіть, будь ласка, інформацію для уточнення вашого місця продажу')">

                    <v-card-text v-show="formSended" class="my-8">
                        <v-alert type="info" outlined>
                            Дякуємо. Дані прийнято.<br>
                            Зачекайте на повідомлення щодо надання доступу.
                        </v-alert>
                    </v-card-text>

                    <v-card-text v-show="!formSended">
                        <!-- v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear -->
                        <validation-provider v-slot="{ errors, valid }" rules="required|max:100">
                            <v-text-field prepend-icon="mdi-city" name="city" label="Мiсто" v-model="f.city" :error-messages="errors" :success="valid" required></v-text-field>
                        </validation-provider>
                        <validation-provider v-slot="{ errors, valid }" rules="required|max:100">
                            <v-text-field prepend-icon="mdi-map-marker" name="address" label="Адреса торгівельної точки" v-model="f.address" :error-messages="errors" :success="valid" required></v-text-field>
                        </validation-provider>
                        <validation-provider v-slot="{ errors, valid }" rules="required|max:30">
                            <v-text-field prepend-icon="mdi-barcode" hint="будь-якого продукту, що був придбаний у Юг-Контракт" name="sn" label="Серійний номер / ІМЕІ " v-model="f.sn" :error-messages="errors" :success="valid" required></v-text-field>
                        </validation-provider>
                    </v-card-text>
                    <v-card-actions v-show="!formSended">
                        <v-spacer></v-spacer>
                        <v-btn color="cardheader" text :loading="loading" @click="passes(submitForm)" :disabled="invalid || !validated">Надiслати</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </material-card>
            </ValidationObserver>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions
} from 'vuex'

export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            loading: false,
            f: {},
            formSended: false,
        }
    },
    methods: {
        ...mapActions(['userClarification']),
        submitForm() {
            this.userClarification(this.f)
                .then(
                    data => {
                        this.formSended = true
                    }
                )
                .catch(error => console.log(error))
        }
    },
    created() {},
    computed: {}
}
</script>

<style>
</style>
